export default __webpack_public_path__ + "assets/tool.11be4391.svg";